(() => {
  const init = (root) => {
    if (root.dataset.colorGuideReady === 'true') return;
    root.dataset.colorGuideReady = 'true';

    const filterButtons = [...root.querySelectorAll('[data-color-filter]')];
    const swatches = [...root.querySelectorAll('[data-color-group]')];
    const dialog = root.querySelector('[data-color-dialog]');
    const dialogImage = root.querySelector('[data-color-dialog-image]');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.colorFilter;

        filterButtons.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', String(candidate === button));
        });

        swatches.forEach((swatch) => {
          const groups = swatch.dataset.colorGroup.split(' ');
          swatch.hidden = filter !== 'all' && !groups.includes(filter);
        });
      });
    });

    root.querySelectorAll('[data-color-zoom]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog || !dialogImage) return;
        dialogImage.src = button.dataset.zoomSrc;
        dialogImage.alt = button.dataset.zoomAlt;
        dialog.showModal();
      });
    });

    root.querySelector('[data-color-dialog-close]')?.addEventListener('click', () => {
      dialog?.close();
    });

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    root.querySelectorAll('[data-color-action]').forEach((link) => {
      link.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'rehair_color_guide_action',
          color_guide_action: link.dataset.colorAction
        });
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-rehair-color-guide]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
